/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import {
  DefaultSelectV2,
  DialogDefaultV2,
  DropzoneV2,
  InputV2,
  UsuarioSelectV2,
  YearMonthPickerV2,
} from '../../../components/v2';

import * as actionsOlerite from '../../../store/olerite/actions';
import * as selectorsOlerite from '../../../store/olerite/reducer';
import * as selectorsAuth from '../../../store/auth/reducer';

const createSchema = {
  tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  mesReferencia: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  usuarioId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  file: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const tipoOptions = [
  { id: 'HOLERITE', nome: 'Holerite' },
  { id: 'INFORME_RENDIMENTO', nome: 'Informe de Rendimento' },
];

/** Normaliza `mesReferencia` para `number` esperado pelo YearMonthPickerV2. */
function toPickerMesReferencia(raw, tipo) {
  if (raw == null || raw === '') {
    return tipo === 'INFORME_RENDIMENTO'
      ? moment().startOf('year').valueOf()
      : moment().startOf('month').valueOf();
  }
  if (typeof raw === 'number') {
    return raw;
  }
  const informeOnlyYear = tipo === 'INFORME_RENDIMENTO';
  let m;
  if (informeOnlyYear) {
    const s = String(raw);
    const yearDigits = /^\d{4}$/.test(s) ? s : s.slice(0, 4);
    m = moment(yearDigits, 'YYYY', true);
    return m.isValid() ? m.startOf('year').valueOf() : moment().startOf('year').valueOf();
  }
  m = moment(raw, ['YYYY-MM', 'YYYY-MM-DD'], true);
  if (!m.isValid()) {
    m = moment(raw);
  }
  return m.isValid() ? m.clone().startOf('month').valueOf() : moment().startOf('month').valueOf();
}

const FormularioEdicao = ({
  updateOlerite,
  findOleriteById,
  oleriteClearSelected,
  selectedOlerite,
  open,
  id,
  onClose,
  authData,
  adminPermission,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const getDefaultValues = () => ({
    criadoPorId: authData?.id,
    criadoPorNome: authData?.nome,
    mesReferencia: moment().format('YYYY-MM'),
    arquivos: [],
  });

  useEffect(() => {
    if (open && !id) {
      setValues(getDefaultValues());
    }
  }, [id, open]);

  useEffect(() => {
    if (id) {
      findOleriteById(id);
    }
  }, [id, findOleriteById]);

  useEffect(() => {
    if (selectedOlerite && selectedOlerite.id) {
      const tipo = selectedOlerite.tipo || 'HOLERITE';
      setValues({
        ...selectedOlerite,
        tipo,
        mesReferencia:
          selectedOlerite.mesReferencia != null
            ? toPickerMesReferencia(selectedOlerite.mesReferencia, tipo)
            : moment().startOf('month').valueOf(),
      });
    }
  }, [selectedOlerite]);

  const onCloseLocal = (isSave) => {
    oleriteClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    onClose(isSave);
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onSave = () => {
    const erros = validate(values, createSchema);
    setErrors(erros || {});
    if (!erros) {
      updateOlerite(values.id, values, saveCallback);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Holerite"
      confirmMessage="Salvar"
      cancelMessage="Cancelar"
      maxWidth="md"
      fullWidth
      readOnly={!adminPermission}
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <DefaultSelectV2
            label="Tipo"
            name="tipo"
            isRequired
            error={!!(errors && errors.tipo)}
            options={tipoOptions}
            disabled={!adminPermission}
            onSelect={(e) =>
              setValues({ ...values, tipo: e.target.value || null })}
            value={values.tipo}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <YearMonthPickerV2
            label={
              values.tipo === 'HOLERITE'
                ? 'Mês Referência'
                : 'Ano de Referência'
            }
            value={values.mesReferencia}
            onChange={(val) => setValues({ ...values, mesReferencia: val })}
            error={!!errors?.mesReferencia}
            isRequired
            onlyYear={values.tipo === 'INFORME_RENDIMENTO'}
            disabled={!adminPermission}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <InputV2
            label="Criado Por"
            name="criadoPorNomeDisplay"
            value={values.criadoPorNome || ''}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <InputV2
            label="Data Criação"
            name="dataInclusaoValue"
            value={values.dataInclusaoValue || ''}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }}>
          <UsuarioSelectV2
            label="Usuário"
            onSelect={(usuarioId) => setValues({ ...values, usuarioId })}
            ativo
            value={values.usuarioId}
            isRequired
            error={!!(errors && errors.usuarioId)}
            multiSelect={false}
            disabled={!adminPermission}
          />
        </Grid>
        <DropzoneV2
          buttonText="Arquivo"
          filesLimit={1}
          acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
          showGridFiles
          canDeleteFiles
          disabled={!adminPermission}
          error={!!(errors && errors.file)}
          onSave={(files) => {
            if (files != null && files.length > 0) {
              const file = files[0];
              const fileOptions = {
                id: uuidv4(),
                nome: file.name.split('.')[0],
                extensao: file.name.split('.').pop(),
                alt: file.name,
                file,
                new: true,
              };
              setValues({ ...values, file: fileOptions });
            } else {
              setValues({ ...values, file: null });
            }
          }}
          files={
            values.file != null
              ? [
                {
                  file: values.file.file,
                  nome: values.file.alt,
                  onDelete: () => setValues({ ...values, file: null }),
                },
              ]
              : []
          }
        />
      </Grid>
    </DialogDefaultV2>
  );
};

FormularioEdicao.propTypes = {
  updateOlerite: PropTypes.func.isRequired,
  findOleriteById: PropTypes.func.isRequired,
  oleriteClearSelected: PropTypes.func.isRequired,
  selectedOlerite: PropTypes.object,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  authData: PropTypes.object,
  adminPermission: PropTypes.bool,
};

FormularioEdicao.defaultProps = {
  id: null,
  selectedOlerite: null,
  authData: {},
  adminPermission: false,
};

const mapStateToProps = (state) => ({
  selectedOlerite: selectorsOlerite.getSelectedOlerite(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionsOlerite }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormularioEdicao);
